import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class FileService {
	constructor() {}

	getExtensionIcon(ext: string): string {
		const base = "assets/images/extensions/";
		switch (ext) {
			case "pdf":
				return base + "pdf.png";
			case "doc":
			case "docx":
				return base + "word.png";
			case "xls":
			case "xlsx":
				return base + "excel.png";
			case "ppt":
			case "pptx":
				return base + "powerpoint.png";
			case "zip":
				return base + "zip.png";
			case "png":
			case "jpg":
			case "jpeg":
				return base + "image.png";
			default:
				return base + "php.png";
		}
	}

	getMimeType(extension: string): string | false {
		switch (extension) {
			case "png":
				return "image/png";
			case "jpg":
			case "jpeg":
				return "image/jpeg";
			case "pdf":
				return "application/pdf";
			case "doc":
				return "application/msword";
			case "docx":
				return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
			case "xls":
				return "application/vnd.ms-excel";
			case "xlsx":
				return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
			case "ppt":
				return "application/vnd.ms-powerpoint";
			case "pptx":
				return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
			case "zip":
				return "application/zip";
		}
		return false;
	}
}
